module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-8.28a1ff96.svg";